export default "__VITE_ASSET__5VhNm_KJ__"